type TValue = {
  period: number | 'hours24' | 'anytime' | 'range';
  startDate: Date | null;
  stopDate: Date | null;
};

type THandler = (value: TValue) => void;

type TOption = {
  value: TValue['period'] | TValue;
  label: string;
};

const VALID_PERIOD_SET = new Set(['hours24', 0, 1, 7, 30, 'anytime', 'range']);

const DEFAULT_OPTIONS: TOption[] = [
  {value: 'hours24', label: 'hours24'},
  {value: 0, label: 'day'},
  {value: 1, label: 'yesterday'},
  {value: 7, label: 'week'},
  {value: 30, label: 'month'},
  {value: 'anytime', label: 'anytime'},
  {value: 'range', label: 'range'},
];

const DATE_FORMAT = 'dd.MM.yyyy';
const EMPTY_DATE_FORMAT = 'XX.XX.XXXX';

export {DEFAULT_OPTIONS, DATE_FORMAT, EMPTY_DATE_FORMAT, VALID_PERIOD_SET};
export type {THandler, TOption, TValue};
